var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-card", { attrs: { flat: "", color: "accent" } }, [
    _c("p", { staticClass: "title text-xs-center pa-2" }, [
      _vm._v(_vm._s(_vm.$t("site-title")) + " is currently in a "),
      _c("strong", [_vm._v("Free Public Beta")]),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "subheading" }, [
        _vm._v("Checkout our "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.livestocktransportnation.com/load-pricing",
              target: "_blank"
            }
          },
          [_vm._v("Pricing Page")]
        ),
        _vm._v(" for more details")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e85e6a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e85e6a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FreeBeta.vue
// module id = null
// module chunks = 